<div class="icn-dropdown-container">
  <!-- Preview of selected icon (optional) -->
  <div *ngIf="iconControl.value" class="selected-icn-preview">
    <i [class]="iconControl.value.className"></i>
  </div>

  <mat-form-field appearance="outline" class="icn-select-field full-width">
    <mat-label>{{ label }}</mat-label>

    <mat-select [formControl]="iconControl" [placeholder]="placeholder">
      <mat-option *ngFor="let icon of icons" [value]="icon">
        <div class="icn-option">
          <i [class]="icon.className" class="icn-preview mr--sm"></i>
          <span class="icn-name">{{ icon.name }}</span>
        </div>
      </mat-option>
    </mat-select>

    <div *ngIf="loading" class="loading-spinner">
      <mat-spinner diameter="20"></mat-spinner>
    </div>

    <mat-error *ngIf="error">{{ error }}</mat-error>
  </mat-form-field>
</div>
